import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { DatasetFacade, RepublishDialogService } from '@mode/dataset/contract';
import { RepublishDatasetDialogComponent } from './republish-dataset-dialog.component';
import { take } from 'rxjs/operators';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Injectable()
export class RepublishDatasetDialogService extends RepublishDialogService {
  constructor(
    private dialogService: DialogService,
    private datasetFacade: DatasetFacade,
    private metaTag: MetaTagsService,
    private analyticsService: AnalyticsService
  ) {
    super();
  }

  public override open(switchViewToken: string) {
    const currentDialog = this.dialogService.open({
      component: RepublishDatasetDialogComponent,
      matDialogConfig: {
        data: {
          switchViewToken,
        },
      },
    });

    this.listenToDialogEvent(currentDialog);
  }

  private listenToDialogEvent(currentDialog: MatLegacyDialogRef<RepublishDatasetDialogComponent>) {
    currentDialog.componentInstance.republish
      .pipe(take(1))
      .subscribe(({ datasetThoughtspotPublicationToken }: { datasetThoughtspotPublicationToken: string }) => {
        this.datasetFacade.republishDataset(datasetThoughtspotPublicationToken);
        const eventData = {
          context: this.analyticsService.context,
          location: AnalyticsEvent.SubContext.RepublishDatasetModal,
          action: AnalyticsEvent.Name.DatasetRepublished,
          name: this.metaTag.getTag(MetaTags.CurrentUsername),
        };
        this.analyticsService.track(AnalyticsEvent.Name.UiClicked, eventData);
      });
  }
}
